import { CIcon } from '~/icons/types'

export const ciBoatLicenses: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M21.186 1H5.317a.5.5 0 0 0-.5.5v1.951h-.045a1.771 1.771 0 0 0 0 3.541h.045v.816h-.045a1.771 1.771 0 0 0 0 3.541h.045v.815h-.045a1.77 1.77 0 0 0 0 3.541h.045v.815h-.045a1.771 1.771 0 0 0 0 3.542h.045v1.95a.5.5 0 0 0 .5.5h15.869a.5.5 0 0 0 .5-.5V1.5a.5.5 0 0 0-.5-.5ZM4.772 5.992a.771.771 0 0 1 0-1.541h.045v1.541h-.045Zm0 4.357a.771.771 0 0 1 0-1.541h.045v1.541h-.045Zm0 4.356a.771.771 0 0 1 0-1.541h.045v1.541h-.045Zm0 4.357a.77.77 0 1 1 0-1.542h.045v1.542h-.045Zm15.914 2.45H5.817V17.52h.045a.771.771 0 0 1 .77.771.5.5 0 0 0 1 0 1.772 1.772 0 0 0-1.77-1.771h-.045v-3.356h.045a.771.771 0 0 1 .77.771.5.5 0 0 0 1 0 1.772 1.772 0 0 0-1.77-1.771h-.045V8.808h.045a.77.77 0 0 1 .77.77.5.5 0 0 0 1 0 1.771 1.771 0 0 0-1.77-1.77h-.045V4.451h.045a.771.771 0 0 1 .77.771.5.5 0 1 0 1 0 1.772 1.772 0 0 0-1.77-1.771h-.045V2h14.869v19.512Z'
    },
    {
      d:
        'M16.073 17.652h-3.93a.5.5 0 1 0 0 1h3.935a.5.5 0 1 0 0-1h-.005Zm1.771-2.402h-7.48a.5.5 0 0 0 0 1h7.48a.5.5 0 0 0 0-1Zm-4.238-2.2v.3a.5.5 0 1 0 1 0v-.3a4.263 4.263 0 0 0 3.772-4.221.5.5 0 0 0-1 0 3.268 3.268 0 0 1-2.772 3.22V7.82h1.009a.5.5 0 0 0 0-1h-1.009v-.614a1.254 1.254 0 1 0-1 0v.614h-1.009a.5.5 0 0 0 0 1h1.009v4.23a3.268 3.268 0 0 1-2.771-3.221.5.5 0 0 0-1 0 4.262 4.262 0 0 0 3.771 4.222Zm.5-8.246a.254.254 0 0 1 .254.254c0 .282-.51.28-.509 0a.255.255 0 0 1 .255-.254Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'boat-licenses',
  type: 'thin'
}
